export default __webpack_public_path__ + "static/media/447.1e7c0192.jpg";